module.exports = __webpack_public_path__ + "img/stock-photo-134067119.dc3fe510.jpg";